export default __webpack_public_path__ + "images/12.27b6cba.png";